import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import _ from 'lodash';

// Utils
import { createSlugFromTitle } from '../../utils';

// Components
import Icon from '../Icon';
import Logo from '../Logo';
import { FlaskIcon } from '../AnimatedIcons';

// Styles
import {
  ResearchCardWrapper,
  LogoWrapper,
  FoodSection,
  ResultsSection,
  StyledFoodName,
  StyledIntroHeading,
  StyledPreventsHeading,
  Links
} from './ResearchCardStyles';

const createLinks = links => links.map((link, i) => /http/.test(link)
  ? <span key={`link-${i}`}><a href={link} target='_blank'>[{i + 1}]</a> </span>
  : '');

const ResearchCard = ({ title, content, heading, link1, link2, link3, prevents, reliability }) => {
  const baseColor = content.themecolor || 'rgb(0, 0, 0)';
  const themeColors = baseColor.split('-');
  const textColor = content.textcolor || 'rgb(255, 255, 255)';

  return (
    <ResearchCardWrapper>
      <FoodSection>
        <FlaskIcon width={120} height={120} type='flask' colors={themeColors} />
        <StyledFoodName themeColors={themeColors} textColor={textColor}><Link to={`/${createSlugFromTitle(title)}/`}>{title}</Link></StyledFoodName>
      </FoodSection>
      <ResultsSection>
        <StyledIntroHeading>{heading}</StyledIntroHeading>
        <StyledPreventsHeading themeColors={themeColors} textColor={textColor}>
          <Link to={`/${createSlugFromTitle(title)}/`}>{prevents}</Link>
        </StyledPreventsHeading>
        <p>Reliability: {reliability}. {createLinks([link1, link2, link3])}</p>
        <Links></Links>
      </ResultsSection>
    </ResearchCardWrapper>
  )
};

ResearchCard.propTypes = {
  content: PropTypes.object.isRequired,
  reliability: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  prevents: PropTypes.string.isRequired,
  link1: PropTypes.string,
  link2: PropTypes.string,
  link3: PropTypes.string
};

ResearchCard.defaultProps = {
  link1: null,
  link2: null,
  link3: null
};

export default ResearchCard;



// WEBPACK FOOTER //
// ./src/components/ResearchCard/ResearchCard.jsx